import { getFormattedDate, getFormattedDateIncludeSeconds, getFormattedDateIncludeTime } from '@frontend-site/shared/utils';

/**
 * GET FORMATTED DATE
 *
 * @param date
 * any input which is valid for JS Date object will be valid here
 * Note: strings like "12-**" are valid in some browsers.
 *
 * @return
 * date as string in the following format: 'dd-MMM-yyyy' OR empty string for undefined or invalid input
 */
export function getFormattedDateForGrid(date: Date | undefined | string | number | null): string {
    if (!date) {
        return '';
    }

    return getFormattedDate(date) || '';
}

/**
 * GET FORMATTED DATE INCLUDES TIME
 *
 * @param date
 * any input which is valid for JS Date object will be valid here
 * Note: strings like "12-**" are valid in some browsers.
 *
 * @return
 * date as string in the following format: 'dd-MMM-yyyy HH:mm' OR empty string for undefined or invalid input
 */
export function getFormattedDateIncludesTimeForGrid(date: Date | undefined | string | number): string {
    if (!date) {
        return '';
    }

    return getFormattedDateIncludeTime(date) || '';
}

/**
 * GET FORMATTED DATE INCLUDE SECONDS
 *
 * @param date
 * any input which is valid for JS Date object will be valid here
 * Note: strings like "12-**" are valid in some browsers.
 *
 * @return
 * date as string in the following format: 'dd-MMM-yyyy HH:mm:ss' OR empty string for undefined or invalid input
 */
export function getFormattedDateIncludeSecondsForGrid(date: Date | undefined | string | number): string {
    if (!date) {
        return '';
    }

    return getFormattedDateIncludeSeconds(date) || '';
}
